import React, {Suspense, Component, ReactNode} from 'react';
import {matchPath, Redirect, Route, RouteComponentProps, Switch, withRouter} from 'react-router';

import LoaderOverlay from "../../components/LoaderOverlay";
import {RouteDefinition} from "../../navigation/types";

import DashboardLayout from "../DashboardLayout";
import './AppLayout.scss';

type AppLayoutType = {
    routes: Array<RouteDefinition>;
};

export class AppLayout extends Component<AppLayoutType & RouteComponentProps> {

    constructor(props: any) {
        super(props);
    }

    public render(): ReactNode {
        const {routes, history} = this.props;

        /**
         * internal routes, need to be login
         */
        const privateRoutes = routes.filter(route => route.access);

        /**
         * public routes, can acces guests
         */
        const publicRoutes = routes.filter(route => !route.access);

        if(this.is404Route(this.props, routes)){
            return this.publicLayout(publicRoutes);
        }

        if (this.isPublicRoute(this.props, publicRoutes)) {
            return this.publicLayout(publicRoutes);
        }

        if (this.isPrivateRoute(this.props, privateRoutes)){
            return this.privateLayout(privateRoutes);
        }

        return this.notFoundRoute();
    }

    public privateLayout(privateRoutes: Array<RouteDefinition>): ReactNode {

        if (this.checkPrivateRouteMatche(this.props, privateRoutes)) {
            return <DashboardLayout routes={privateRoutes} getDefaultRoute={this.getDefaultRoute}/>
        }
        return this.notFoundRoute();

    }

    private checkPrivateRouteMatche(props: any, routes: Array<RouteDefinition>) {
        let found = routes.find(route => {
            return matchPath(props.history.location.pathname, {path: route.path, exact: true})
        });
        return typeof found !== 'undefined';
    }

    private routeTree(arg: RouteDefinition[], keyPrefix: string = 'route'): ReactNode {
        return arg.map(route => <Route key={`${keyPrefix}-${route.name}`} {...route} />);
    }

    /**  default route, why neee ? idk TODO **/
    private getDefaultRoute(availableRoutes: RouteDefinition[]): ReactNode {
        if (availableRoutes && availableRoutes.length) {
            return <Redirect to={availableRoutes[0].path}/>;
        }
        return <Redirect to="/404"/>;
    };

    private publicLayout(publicRoutes: Array<RouteDefinition>): ReactNode {
        return (
            <Suspense fallback={<LoaderOverlay/>}>
                <Switch>
                    {this.routeTree(publicRoutes)}
                    {this.getDefaultRoute(publicRoutes)}
                </Switch>
            </Suspense>
        );
    }

    private notFoundRoute(): ReactNode {
        return <h2></h2>;
    }

    private is404Route(props: any, routes: Array<RouteDefinition>) {
        let found = routes.find(route => {
            if(route.path !== '*') {
                return matchPath(props.history.location.pathname, {path: route.path, exact: true})
            }
        });
        return typeof found === 'undefined';
    }


    private isPublicRoute(props: any, publicRoutes: Array<RouteDefinition>) {
        let found = publicRoutes.find(route => {
            if(route.path !== '*') {
                return matchPath(props.history.location.pathname, {path: route.path, exact: true})
            }
        });
        return typeof found !== 'undefined';
    }

    private isPrivateRoute(props: any, privateRoutes: Array<RouteDefinition>) {
        let found = privateRoutes.find(route => {
            if(route.path !== '*') {
                return matchPath(props.history.location.pathname, {path: route.path, exact: true})
            }
        });
        return typeof found !== 'undefined';
    }
}

export default withRouter(AppLayout);
